import getRequestsNetworkSelector
from 'modules/training/modules/network/selectors/get-requests'

function addRequestNetworkUtil (params) {
  const { action } = params
  const { path } = action.payload
  const requests = getRequestsNetworkSelector()(params.state)
  if (requests.find(request => request.action.payload.path === path)) {
    return requests
  }
  const requestData = {
    retryCount: 0,
    isSaving: false,
    action
  }
  return [
    ...requests,
    requestData
  ]
}

export default addRequestNetworkUtil
